import Vue from "vue";
import VueI18n from "vue-i18n";
import principles from "@/locales/principles";
import friends from "@/locales/friends";
import prices from "@/locales/prices";
import common from "@/locales/common";
import footer from "@/locales/footer";
import registration from "@/locales/registration";
import eveningProgram from "@/locales/eveningProgram";
import events from "@/locales/events";
import book from "@/locales/book";
import team from "@/locales/team";
import lectors from "@/locales/lectors";
import archive from "@/locales/archive";
import help from "@/locales/help";
import transfer from "@/locales/transfer";
import { loadLocaleData } from "@/utils/loadLocaleData";

Vue.use(VueI18n);

const selectedLocale = localStorage.getItem("locale") ?? "en";

export default new VueI18n({
  locale: selectedLocale,
  fallbackLocale: selectedLocale,
  messages: {
    ...loadLocaleData({
      principles,
      friends,
      eveningProgram,
      events,
      prices,
      common,
      registration,
      footer,
      book,
      team,
      lectors,
      archive,
      help,
      transfer
    })
  }
});
